import type { GetCampaigns } from '@/pages/app/campaigns/types'
import { api } from '@/services/axios'

export async function getCampaigns(): Promise<GetCampaigns[]> {
  const response = await api.get<GetCampaigns[]>('Campanha/GetAll')

  return response.data
}
